export default {
    dependencies: ['$element', 'trackingservice'],
    callable(ele, trackingservice) {
        trackingservice.setContextParam({
            list3: createList3ValueForReplyTime(ele),
        });

        const objectCustom = {
            replyTimeBucketABtest: extractPulseTrackingVariables(ele),
        };

        trackingservice.setContextParam({
            objectCustom,
        });

        function extractPulseTrackingVariables(ele) {
            const attr = createList3ValueForReplyTime(ele);
            if (attr) {
                return attr
                    .split(',')
                    .map(part => part.split(':'))
                    .reduce((result, entryArray) => {
                        const [key, value] = entryArray;
                        if (value != null) {
                            result[key] = value;
                        }
                        return result;
                    }, {});
            } else {
                return {};
            }
        }

        function createList3ValueForReplyTime(ele) {
            return ele.getAttribute('data-reply-time') || '';
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/replyTimeTracking.js